import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import {
  debounceTime, distinctUntilChanged, switchMap, filter
} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { Patient } from '../patient';
import { PatientService } from '../../service/patient.service';

import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'mc-patient-index',
  templateUrl: './patient-index.component.html',
  styleUrls: ['./patient-index.component.scss']
})
export class PatientIndexComponent implements OnInit {

  public patients: Patient[];
  private searchTerms = new Subject<string>();
  term: string;

  constructor(
    private patientService: PatientService,
    private notifService: ToastrService,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit() {
    this.searchTerms.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((term: string) => this.patientService.searchPatient(term))
    ).subscribe(
      patients => this.patients = patients,
      error => this.notifService.error(error)
    );

    this.route.queryParams.pipe(
      filter(params => params.term)
    ).subscribe(params => {
      if (params.term) {
        this.term = params.term;
        this.searchTerms.next(params.term);
      }
    });
  }

  search(term: string): void {
    if (term.length < 3) { return; }

    this.searchTerms.next(term);

    let path: string = this.location.path();
    if (path.includes('?term')) {
      this.location.go(path.replace(/term.*$/, `term=${term}`));
    } else {
      this.location.go(`${path}?term=${term}`);
    }
  }
}
